import { createVNode, mergeProps } from "vue";
export default {
  name: 'VolumeXIcon',
  props: {
    size: {
      type: String,
      default: '16',
      validator: s => !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
    }
  },

  setup(props, ctx) {
    const size = props.size.slice(-1) === 'x' ? props.size.slice(0, props.size.length - 1) + 'em' : parseInt(props.size) + 'px';
    const attrs = { ...ctx.attrs
    };
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    return () => createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "class": "feather feather-volume-x"
    }, { ...attrs
    }), [createVNode("polygon", {
      "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
    }), createVNode("line", {
      "x1": "23",
      "y1": "9",
      "x2": "17",
      "y2": "15"
    }), createVNode("line", {
      "x1": "17",
      "y1": "9",
      "x2": "23",
      "y2": "15"
    })]);
  }

};